/**
 * DOZY SURVEY — a aplicação do avaliador técnico.
 *
 * Mesma escolha que se fez para o Field Agent: não é o painel com menos
 * itens, é outra aplicação. O avaliador está numa obra, de pé, a medir
 * paredes com uma mão e a segurar o telemóvel com a outra. Não há barra
 * lateral, os alvos são grandes, e cada visita está a um toque.
 *
 * O que ele NÃO tem, de propósito: preços. O documento é claro — o avaliador
 * identifica e quantifica o trabalho, não determina o valor comercial da
 * obra. Um campo de kwanzas aqui abriria a porta a isso.
 */
import React, { useContext } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { ClipboardList, LogOut, UserCog } from 'lucide-react';
import { AuthContext } from '../../context/AuthContext';
import SurveyHome from './SurveyHome';
import SurveyReport from './SurveyReport';
import AccountPage from '../AccountPage';

const NAV = [
  { para: '/admin', rotulo: 'Visitas', icone: ClipboardList, exacto: true },
  { para: '/admin/account', rotulo: 'Conta', icone: UserCog },
];

const SurveyLayout = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const local = useLocation();

  const sair = async () => { await logout(); navigate('/'); };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col">
      <header className="flex items-center gap-3 px-4 py-3 border-b border-slate-800 sticky top-0 bg-slate-950 z-20">
        <span className="grid place-items-center w-9 h-9 rounded-xl bg-cyan-600 font-bold">D</span>
        <div className="flex-1 min-w-0">
          <div className="font-bold leading-tight">DOZY SURVEY</div>
          <div className="text-xs text-slate-500 truncate">{user?.full_name}</div>
        </div>
        <button onClick={sair} aria-label="Terminar sessão"
          className="grid place-items-center w-11 h-11 rounded-xl text-slate-400 hover:text-red-400 hover:bg-slate-900">
          <LogOut className="w-5 h-5" />
        </button>
      </header>

      {/* Espaço para as duas barras que vivem em baixo: a navegação e, nos
          ecrãs de formulário, a barra de acção por cima dela. */}
      <main className="flex-1 p-4 pb-44">
        <Routes>
          <Route path="/" element={<SurveyHome />} />
          <Route path="/visitas/:id" element={<SurveyReport />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>

      <nav className="fixed bottom-0 inset-x-0 flex border-t border-slate-800 bg-slate-950 pb-[env(safe-area-inset-bottom)]">
        {NAV.map(({ para, rotulo, icone: Icone, exacto }) => {
          const activo = exacto ? local.pathname === para : local.pathname.startsWith(para);
          return (
            <button key={para} onClick={() => navigate(para)}
              aria-current={activo ? 'page' : undefined}
              className={`flex-1 flex flex-col items-center gap-1 py-3 text-xs font-medium
                ${activo ? 'text-cyan-400' : 'text-slate-500'}`}>
              <Icone className="w-5 h-5" />
              {rotulo}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default SurveyLayout;
